module.exports = __webpack_public_path__ + "img/header-logo.2d24531f.png";